import { fromDate, toCalendarDate } from '@internationalized/date';
import { formatDateTime } from '@customerio/pluma-components/react/utils/formatted-date-time';
import { BILLING_TIME_ZONE } from '@/services/billing/time-zone';

/**
 * The first billing date shown on a monthly plan, e.g. "July 24, 2026": one month from today.
 *
 * Today is the date in the billing time zone, not the viewer's. Stripe starts the cycle on that date.
 *
 * @param now - the moment the checkout is read, for tests
 */
export function nextBillDateLabel(now: Date = new Date()): string {
  const todayInBillingZone = toCalendarDate(fromDate(now, BILLING_TIME_ZONE));
  const nextBillDate = todayInBillingZone.add({ months: 1 });
  return formatDateTime(nextBillDate.toDate(BILLING_TIME_ZONE), 'medium', {
    day: 'numeric',
    month: 'long',
    timeZone: BILLING_TIME_ZONE,
  });
}
